import React from "react";

const Contact = () => (
  <div className="container py-5">
    <section className="contact-section">
      <div className="card shadow-lg border-0">
        <div className="card-body p-5">
          <div className="text-center mb-5">
            <h3 style={{ color: "#ff6f00" }}>
              <strong>Contact Our B2B Partnership Team</strong>
            </h3>
            <p style={{ color: "#555" }}>
              Connect with us for tailored solutions and partnership
              opportunities. Our experts are ready to assist you!
            </p>
          </div>

          {/* Contact Form */}
          <form>
            <div className="row">
              <div className="col-md-6 mb-4">
                <input
                  type="text"
                  id="Form-name"
                  className="form-control"
                  placeholder="Full Name"
                />
              </div>
              <div className="col-md-6 mb-4">
                <input
                  type="email"
                  id="Form-email"
                  className="form-control"
                  placeholder="Business Email"
                />
              </div>
              <div className="col-md-6 mb-4">
                <input
                  type="text"
                  id="Form-company"
                  className="form-control"
                  placeholder="Company Name"
                />
              </div>
              <div className="col-md-6 mb-4">
                <input
                  type="text"
                  id="Form-position"
                  className="form-control"
                  placeholder="Job Title"
                />
              </div>
              <div className="col-md-6 mb-4">
                <input
                  type="tel"
                  id="Form-phone"
                  className="form-control"
                  placeholder="Phone Number"
                />
              </div>
              <div className="col-md-6 mb-4">
                <input
                  type="url"
                  id="Form-website"
                  className="form-control"
                  placeholder="Company Website"
                />
              </div>
              <div className="col-md-12 mb-4">
                <select id="Form-interest" className="form-control">
                  <option value="">Select Your Area of Interest</option>
                  <option value="partnerships">Partnerships</option>
                  <option value="solutions">Solutions</option>
                  <option value="support">Support</option>
                  <option value="others">Others</option>
                </select>
              </div>
              <div className="col-md-12 mb-4">
                <textarea
                  id="FormContactMessage"
                  className="form-control"
                  rows="4"
                  placeholder="Your Message"
                />
              </div>
            </div>

            <div className="text-center">
              <button
                type="submit"
                className="btn  btn-block rounded-pill"
                style={{ backgroundColor: "#ff6f00", borderColor: "#ff6f00" }}
              >
                Send Message <i className="fa fa-paper-plane ml-2" />
              </button>
            </div>
          </form>
        </div>
      </div>
    </section>

    {/* Additional Contact Details */}
    <section className="contact-info-section mt-5">
      <div className="row text-center">
        {/* Address Block */}
        <div className="col-lg-4 col-md-6 mb-4">
          <div className="card contact-card border-0 shadow-sm">
            <div className="card-body">
              <i
                className="fa fa-map-marker fa-2x mb-3"
                style={{ color: "#2F2B5D" }}
              />
              <h5 className="font-weight-bold">Our Office</h5>
              <p style={{ color: "#555" }}>
                578 Commerce Street, San Francisco, TX 79524
              </p>
            </div>
          </div>
        </div>

        {/* Phone Block */}
        <div className="col-lg-4 col-md-6 mb-4">
          <div className="card contact-card border-0 shadow-sm">
            <div className="card-body">
              <i
                className="fa fa-phone fa-2x mb-3"
                style={{ color: "#2F2B5D" }}
              />
              <h5 className="font-weight-bold">Phone</h5>
              <p style={{ color: "#555" }}>
                +1 210-225-2544 <br /> Mon - Fri, 9am - 6pm
              </p>
            </div>
          </div>
        </div>

        {/* Email Block */}
        <div className="col-lg-4 col-md-12 mb-4">
          <div className="card contact-card border-0 shadow-sm">
            <div className="card-body">
              <i
                className="fa fa-envelope fa-2x mb-3"
                style={{ color: "#2F2B5D" }}
              />
              <h5 className="font-weight-bold">Email</h5>
              <p style={{ color: "#555" }}>
                support@myccwtt.com <br /> Response time: within 24 hours
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Преимущества компании */}
      <section className="py-5 text-center">
        <div className="container">
          <h2 style={{ color: "#2F2B5D" }}>Why Choose Us?</h2>
          <p className="lead" style={{ color: "#555" }}>
            We offer tailored B2B solutions for our partners, ensuring
            exceptional service and reliability:
          </p>
          <div className="row">
            <div className="col-md-4">
              <i
                className="fa fa-calendar-check fa-3x mb-3"
                style={{ color: "#ff6f00" }}
              />
              <h4 style={{ color: "#2F2B5D" }}>Flexible Booking</h4>
              <p style={{ color: "#555" }}>
                Adapt to your clients' needs with our flexible booking options,
                designed for corporate travel arrangements.
              </p>
            </div>
            <div className="col-md-4">
              <i
                className="fa fa-shield-alt fa-3x mb-3"
                style={{ color: "#ff6f00" }}
              />
              <h4 style={{ color: "#2F2B5D" }}>Secure Transactions</h4>
              <p style={{ color: "#555" }}>
                We employ top-tier security measures to ensure safe and reliable
                transactions for all your B2B needs.
              </p>
            </div>
            <div className="col-md-4">
              <i
                className="fa fa-users fa-3x mb-3"
                style={{ color: "#ff6f00" }}
              />
              <h4 style={{ color: "#2F2B5D" }}>24/7 Expert Support</h4>
              <p style={{ color: "#555" }}>
                Our dedicated support team is available around the clock to
                assist with any inquiries or concerns.
              </p>
            </div>
          </div>
        </div>
      </section>
    </section>
  </div>
);

export default Contact;



// WEBPACK FOOTER //
// ./src/components/Contact/contact.js